import fs from "node:fs/promises";
import path from "node:path";

import { Media } from "../models/media";
import { logger } from "./logger";

/**
 * Cleanup expired temporary files from Media model
 */
export async function cleanupExpiredMediaFiles(): Promise<number> {
  try {
    const expiredFiles = await Media.findExpiredFiles();
    const uploadDir = path.join(process.cwd(), "uploads");
    let deletedCount = 0;

    for (const media of expiredFiles) {
      try {
        // Delete physical file
        const filePath = path.join(uploadDir, media.fileName);

        try {
          await fs.unlink(filePath);
          logger.info(`Deleted expired file: ${filePath}`);
        } catch (error: any) {
          if (error.code !== "ENOENT") {
            logger.error(`Error deleting file ${filePath}:`, error);
          }
        }

        // Delete Media record
        await Media.findByIdAndDelete(media._id);
        deletedCount++;
      } catch (error) {
        logger.error(
          `Error cleaning up expired file ${String(media._id)}:`,
          error,
        );
      }
    }

    if (deletedCount > 0) {
      logger.info(`Cleaned up ${deletedCount} expired files`);
    }

    return deletedCount;
  } catch (error) {
    logger.error("Error in cleanupExpiredMediaFiles:", error);
    throw error;
  }
}

/**
 * Delete a single file from disk
 */
export async function deleteFileFromDisk(fileName: string): Promise<void> {
  try {
    const uploadDir = path.join(process.cwd(), "uploads");
    const filePath = path.join(uploadDir, fileName);

    await fs.unlink(filePath);
    logger.info(`Deleted file from disk: ${filePath}`);
  } catch (error: any) {
    if (error.code !== "ENOENT") {
      logger.error(`Error deleting file ${fileName}:`, error);
      throw error;
    }
  }
}

/**
 * Delete multiple files from disk
 */
export async function deleteFilesFromDisk(fileNames: string[]): Promise<void> {
  for (const fileName of fileNames) {
    try {
      await deleteFileFromDisk(fileName);
    } catch (error) {
      logger.error(`Error deleting file ${fileName}:`, error);
    }
  }
}
